<div class="vaccination-reminder-banner-dialog">
    <h1 class="mat-display-medium" mat-dialog-title>Vaccination Reminder</h1>
  <mat-dialog-content [innerHtml]="vaccinationMessage">
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onUpdate()" class="close-btn">Upload
      now</button>
    <button mat-raised-button mat-dialog-close class="close-btn">Close</button>
  </mat-dialog-actions>
</div>